import { render, staticRenderFns } from "./CustomMediaControl.vue?vue&type=template&id=9622d510&"
import script from "./CustomMediaControl.vue?vue&type=script&lang=js&"
export * from "./CustomMediaControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/ligo/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9622d510')) {
      api.createRecord('9622d510', component.options)
    } else {
      api.reload('9622d510', component.options)
    }
    module.hot.accept("./CustomMediaControl.vue?vue&type=template&id=9622d510&", function () {
      api.rerender('9622d510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/CustomMediaControl.vue"
export default component.exports